import React from "react";
import {Box, Image, Link, Text} from "@chakra-ui/react";
import {Color} from "util/Color";

interface Props {
    title: string;
    imageSrc: string;
    url: string;
}

export const Version = React.memo<Props>(({title, imageSrc, url}) => {
    return (
        <Link href={url} _hover={{ textDecoration: 'none' }}>
            <Box textAlign="center" m={{base: 4, sm: 5, md: 5, lg: 8}} backgroundColor="rgb(255 255 255 / 50%)" borderRadius={{base: "20px", sm: "20px", md: "30px", lg: "40px"}}>
                <Text p={{base: 3, sm: 3, md: 3, lg: 4}} fontSize={{base: "22px", sm: "22px", md: "22px", lg: "28px"}} color={Color.camelia}>
                    {title}
                </Text>
                <Image w="500px" h="auto" src={imageSrc} borderBottomRadius={{base: "20px", sm: "20px", md: "30px", lg: "40px"}} />
            </Box>
        </Link>
    );
});
